module.exports = __webpack_public_path__ + "img/14_Distal-D.937ffd9e.png";